import { render, staticRenderFns } from "./CommercialList.vue?vue&type=template&id=81cf55f6"
import script from "./CommercialList.vue?vue&type=script&lang=js"
export * from "./CommercialList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports